import { HeroSection } from './components/HeroSection'
import { ServicesOverviewSection } from './components/ServicesOverviewSection'
import { ProductTeaserSection } from './components/ProductTeaserSection'
import { WhyUsSection } from './components/WhyUsSection'
import { ProcessSection } from './components/ProcessSection'
import { CtaBannerSection } from './components/CtaBannerSection'

export function HomeFeature() {
  return (
    <>
      <HeroSection />
      <ServicesOverviewSection />
      <ProductTeaserSection />
      <WhyUsSection />
      <ProcessSection />
      <CtaBannerSection />
    </>
  )
}
